export default {
  title: 'Utwórz klucz API',
  reveal_warning: 'Zapisz ten klucz teraz — nie zostanie pokazany ponownie.',
  form: {
    name: 'Nazwa',
    name_placeholder: 'np. Klucz produkcyjny',
  },
  buttons: {
    cancel: 'Anuluj',
    create: 'Utwórz',
    done: 'Gotowe',
  },
  toasts: {
    error: 'Nie udało się utworzyć klucza. Spróbuj ponownie.',
  },
};
